import { ShieldCheck, AlertTriangle, Lock } from "lucide-react";
import { getInsightBySlug } from "@/data/insights";

export const ZeroTrustDmarcHeroSection = () => {
  const insight = getInsightBySlug("zero-trust-email-dmarc");
  
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-background via-background to-muted/30" />
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[600px] bg-destructive/5 rounded-full blur-3xl" />
      
      <div className="relative max-w-4xl mx-auto px-4 sm:px-6 pt-8 sm:pt-12 pb-8">
        <div className="text-center">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-destructive/10 text-destructive text-sm font-medium mb-5">
            <ShieldCheck className="w-4 h-4" />
            {insight?.tag}
          </div>
          
          <h1 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-foreground mb-4">
            Zero-Trust Email
          </h1>
          <p className="text-lg sm:text-xl text-destructive font-medium mb-4">
            Why DMARC is No Longer Optional in 2026
          </p>
          <p className="text-muted-foreground text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            {insight?.description}
          </p>
          
          <div className="flex flex-wrap justify-center gap-6 sm:gap-10">
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-2xl sm:text-3xl font-bold text-foreground">
                <Lock className="w-6 h-6 text-destructive" />
                Strict
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">alignment required</div>
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center gap-2 text-2xl sm:text-3xl font-bold text-foreground">
                <AlertTriangle className="w-6 h-6 text-chart-1" />
                p=reject
              </div>
              <div className="text-xs sm:text-sm text-muted-foreground">new baseline</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};